import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SnackbarService } from '@shared/services/snackbar.service';
import { TokenResponse } from '@shared/models/TokenResponse.model';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {

  constructor(
    private http: HttpClient,
    private snackBar: SnackbarService
  ) { }

  public login(username: string, password: string): Observable<TokenResponse> {
    const urlSearchParams = new URLSearchParams(); // keyCloak doesn't accept anything but urlSearchParams.toString() ¯\_(ツ)_/¯
    urlSearchParams.set('grant_type', 'password');
    urlSearchParams.set('client_id', 'web_app');
    urlSearchParams.set('scope', 'send_command write_commandresponse write_device write_user');
    urlSearchParams.set('username', username);
    urlSearchParams.set('password', password);
    return this.http.post<TokenResponse>(`${environment.authUrl}`, urlSearchParams.toString(), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).pipe(
      tap(() => this.snackBar.close())
    );
  }

  public refresh(token: string): Observable<TokenResponse> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('grant_type', 'refresh_token');
    urlSearchParams.set('client_id', 'web_app');
    urlSearchParams.set('refresh_token', token); // same goes here ¯\_(ツ)_/¯
    return this.http.post<TokenResponse>(`${environment.authUrl}`, urlSearchParams.toString(), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

}
